<template>
  <div class="apportionment-details">
    <sdz-modal
      ref="sdzModalRef"
      @close="close"
      width="450"
      title="Detalhes do rateio"
      buttons-position="right"
      hide-cancel-button
      hide-confirm-button
      close-icon
    >
      <div class="apportionment-details-content">
        <v-layout
          wrap
          row
        >
          <v-flex lg12>
            <div>
              <h3>
                Rateio
              </h3>
              <p>{{ details.name ? details.name : 'Grupo' }}</p>
            </div>
          </v-flex>
          <v-flex lg12>
            <div>
              <h3>
                Tipo do Rateio
              </h3>
              <p>{{ onApportionmentTypeType(details.apportionmentType) }}</p>
            </div>
          </v-flex>
          <v-flex lg12>
            <div>
              <h3>
                Visível para vendedor
              </h3>
              <p>{{ details.visibleToSeller ? 'Sim' : 'Não' }}</p>
            </div>
          </v-flex>
          <v-flex lg12>
            <div>
              <h3>
                Acelerador
              </h3>
              <p>{{ onAcceleratorType(details.acceleratorType) }}</p>
            </div>
          </v-flex>
          <v-divider class="mt-3 mb-3" />
          <v-flex lg12>
            <div
              class="functions"
            >
              <div class="item">
                <h3>
                  Função:
                </h3>
                <span class="ml-2">
                  Vendedor
                </span>
              </div>
              <div>
                {{ details.ownerProportion }}%
              </div>
            </div>
            <div
              v-for="({ proportionRole, proportionValue }, index) in details.rules"
              :key="index"
              class="functions"
            >
              <div class="item">
                <h3>
                  Função:
                </h3>
                <span class="ml-2">
                  {{ proportionRole }}
                </span>
              </div>
              <div>
                {{ proportionValue }}%
              </div>
            </div>
          </v-flex>
          <v-divider class="mt-3 mb-3" />
          <v-flex lg12>
            <div>
              <h3>
                Parceiros
              </h3>
              <div
                v-for="({ name }, index) in details.partners"
                :key="index"
              >
                {{ name }}
              </div>
            </div>
          </v-flex>
        </v-layout>
      </div>
    </sdz-modal>
  </div>
</template>

<script>
export default {
  name: 'ApportionmentDetails',

  components: {
    SdzModal: () => import('@/components/sdz/SdzModal.vue')
  },

  props: {
    group: {
      type: Object,
      default: () => {}
    }
  },

  data: () => ({
    details: {}
  }),

  computed: {
    hasRules() {
      return this.details?.rules?.length
    }
  },

  methods: {
    open(payload) {
      this.details = payload
      this.$refs.sdzModalRef.show = true
    },
    close() {
      this.$refs.sdzModalRef.show = false
    },
    onAcceleratorType(value) {
      const types = {
        participant: 'Participante',
        seller: 'Vendedor'
      }
      return types[value]
    },
    onApportionmentTypeType(value) {
      const types = {
        filial: 'Filial',
      }
      return types[value]
    }
  }
}
</script>
 <style lang="stylus" scoped>
  .apportionment-details {
    &-content {
      .layout {
        padding: 26px 16px;
        display: flex;
        flex-direction: column;
      }
      .functions {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .item {
          display: flex;
          align-items: center;
          p {
            margin-bottom: -3px;
          }
        }
      }
    }
  }
 </style>
